module.exports = __webpack_public_path__ + "boxed-bg.7799dece2c79854f63f0.jpg";


//////////////////
// WEBPACK FOOTER
// /var/www/logistic/logistic_frontend/src/img/boxed-bg.jpg
// module id = ../../../../../src/img/boxed-bg.jpg
// module chunks = 8